'use es6';

import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import PropTypes from 'prop-types';
import { getCRMEmailLoggingSettingsUrl } from '../url/getCRMEmailLoggingSettingsUrl';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const EmailAttachmentDisabledBanner = ({
  onClose
}) => {
  return /*#__PURE__*/_jsx(Alert, {
    type: "warning",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-message-history.common-message.attachmentDisabledMessage.title"
    }),
    closeable: true,
    onClose: onClose,
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "conversations-inbox-message-history.common-message.attachmentDisabledMessage.description_jsx",
      elements: {
        UILink: Link
      },
      options: {
        emailLoggingSettingsURL: getCRMEmailLoggingSettingsUrl()
      }
    })
  });
};
EmailAttachmentDisabledBanner.displayName = 'EmailAttachmentDisabledBanner';
EmailAttachmentDisabledBanner.propTypes = {
  onClose: PropTypes.func.isRequired
};
export default EmailAttachmentDisabledBanner;